import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import LayoutWithMap from 'containers/Base/LayoutWithMap';

import {
  taskTypeNameSpace,
  taskTypeFilters,
  taskTypeFilterActions,
  taskTypeSelectors,
  taskTypeActions,
} from 'containers/Pages/Tasks/TaskTypes';
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux';
import { modalState, toggleModal, detailOpenState } from 'reducers/ui';
import useFilters from 'containers/Base/useFilters.js';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import { PAGE_URLS } from 'utils/constants';
import { initialState } from 'containers/Pages/Tasks/TaskTypes/Modules/filters';

const TaskTypes = ({
  columns,
  filtersRequired,
  FormComponent,
  editable,
  details,
  loading,
}) => {
  //---------------------------Selectors---------------------------
  const detailOpen = useSelector(state => detailOpenState(state));
  const services = useSelector(
    state => getSecurityCompanyServices(state),
    shallowEqual,
  );
  const taskTypeListData = useSelector(state =>
    taskTypeSelectors.getTaskTypeList(state),
  );
  const totalEntries = useSelector(state =>
    taskTypeSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    taskTypeSelectors.getFilters(state),
  );
  const forceRefresh = useSelector(state =>
    taskTypeSelectors.getForceRefresh(state),
  );
  const modalOpen = useSelector(state => modalState(state));
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchTaskTypesList = useCallback(
    ({ filters, from }) =>
      dispatch(taskTypeActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(taskTypeNameSpace)),
    [dispatch],
  );
  const TaskTypeFormComponent = useCallback(
    props => <FormComponent {...props} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  //----------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchTaskTypesList({
      filters,
    });
  };
  const fetchTaskTypes = from => {
    dispatchFetchTaskTypesList({
      filters: localFilterValues,
      from,
    });
  };
  return (
    <LayoutWithMap
      header="Task Types"
      cols={columns}
      data={taskTypeListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={editable}
      FormComponent={TaskTypeFormComponent}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[taskTypeNameSpace]}
      //filters
      defaultFilterValues={initialState.filterValues}
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={taskTypeFilters({ services })}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            taskTypeFilterActions.setFilterKey({ key: true });
            taskTypeFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchTaskTypes}
      //setGridAPI={gridAPIHandler}
      persistentStateName={PAGE_URLS.TASK_TYPES.name}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.TASK_TYPES.link]}
    />
  );
};
TaskTypes.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
};
const mapStateToProps = state => ({
  services: getSecurityCompanyServices(state),
});
export default connect(mapStateToProps)(TaskTypes);
